import { ChangeDetectionStrategy, Component, input } from '@angular/core';
import { TranslateModule } from '@ngx-translate/core';

@Component({
    selector: 'app-user-search-title',
    templateUrl: 'user-search-title.component.html',
    imports: [TranslateModule],
    changeDetection: ChangeDetectionStrategy.OnPush
})
export class UserSearchTitleComponent {
    public readonly title = input.required<string>();
    public readonly text = input.required<string>();
}
